import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComplexProjectVO, ProjectVO } from '../../../model/vo/project.vo';
import { UserVO } from '@user/model/vo/user.vo';
import { CadFormatVO } from '@article/components/data-center-export/cad-format.vo';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaeData } from '../../../cae/cae-data.service';

interface CadExportWithLabelingDTO {
  projectId: number;
  projectVersion: number;
  projectDate: string;
  cadFormat: CadFormatVO;
}

@Injectable({ providedIn: 'root' })
export class ProjectExportDataService {

  private readonly baseUrl: string = 'project-export';
  private readonly importProjectFromWSPFileUrl: string = `${this.baseUrl}/import-from-wsp`;
  private readonly exportWSPProjectUrl: string = `${this.baseUrl}/wsp`;
  private readonly importProjectFromCsvUrl: string = `${this.baseUrl}/import-project-csv`;
  private readonly exportProjectToCadUrl: string = `${this.baseUrl}/cad`;
  private readonly exportProjectToCadWithLabelingUrl: string = `${this.baseUrl}/cad-with-labeling`;
  private readonly exportProjectToCalculationUrl: string = `${this.baseUrl}/calculation`;

  constructor(
    private modelConversionService: ModelConversionService,
    private wagoApiClient: WagoApiClient,
  ) {}

  public importProjectFromWSPFile(data: ArrayBuffer): Observable<ComplexProjectVO> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/octet-stream');
    const resultRequestOptions = {
      headers,
    };
    return this.wagoApiClient
      .post(this.importProjectFromWSPFileUrl, data, resultRequestOptions)
      .pipe(map((response) => this.modelConversionService.convertComplexProjectVO(response)));
  }

  public exportWSPProject(project: ProjectVO): Observable<ArrayBuffer> {

    const requestOptions = {
      responseType: 'arraybuffer',
    };

    return this.wagoApiClient.post(this.exportWSPProjectUrl, project, requestOptions);
  }

  public importProjectFromCsv(data: string): Observable<CaeData> {
    return this.wagoApiClient.post(this.importProjectFromCsvUrl, data, undefined, {isErrorHandlingRequired: false});
  }

  public exportProjectToCad(project: ProjectVO, email: string, user: UserVO, cadFormat: CadFormatVO): Observable<boolean> {
    const exportProjectToCadDTO = {
      project,
      email,
      user,
      cadFormat,
    };

    return this.wagoApiClient.post(this.exportProjectToCadUrl, exportProjectToCadDTO, null, {
      isErrorHandlingRequired: false,
    });
  }

  public exportProjectToCadWithLabeling(projectVO: ProjectVO, cadFormat: CadFormatVO): Observable<boolean> {
    const dto: CadExportWithLabelingDTO = {
      projectId: projectVO.id,
      projectVersion: projectVO.currentVersion,
      projectDate: projectVO.modificationDateServerTimeStamp,
      cadFormat: cadFormat,
    };

    return this.wagoApiClient.post(this.exportProjectToCadWithLabelingUrl, dto, null, {
      isErrorHandlingRequired: false,
    });
  }

  public exportProjectToCalculation(projectVO: ProjectVO): Observable<ArrayBuffer> {
    const requestOptions: any = {
      responseType: 'arraybuffer',
    };
    return this.wagoApiClient.post(this.exportProjectToCalculationUrl, projectVO, requestOptions);
  }
}
